module.exports = __webpack_public_path__ + "static/media/map-marker-alt-solid.1e300e4b.png";